import { render, staticRenderFns } from "./cDocumentLevellingEvaluationDetails.vue?vue&type=template&id=d54d380c&scoped=true"
import script from "./cDocumentLevellingEvaluationDetails.vue?vue&type=script&lang=js"
export * from "./cDocumentLevellingEvaluationDetails.vue?vue&type=script&lang=js"
import style0 from "./cDocumentLevellingEvaluationDetails.vue?vue&type=style&index=0&id=d54d380c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54d380c",
  null
  
)

export default component.exports